module.exports = global["origin"] = require("-!./origin.js");


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/origin.js-exposed
// module id = 10
// module chunks = 0